<div>
  <ul class="flex">
    <li>
      <div class="icon-wrap"></div>
      <div class="flex-center dot-wrap"><span class="start-line"></span><span class="line"></span></div>
    </li>
    <li *ngFor="let status of statusList">
      <div class="icon-wrap">
        <svg-icon [iconName]="status.icon+'.svg'" [size]="34"></svg-icon>
      </div>
      <div class="flex-center dot-wrap"><span [ngClass]="{'line':status.isActive,'grey-line':!status.isActive}"></span>
        <div  *ngIf="status.isStatus" class="dot-line-wrap flex-center">
          <span  [ngClass]="{'dot-line':status.isActive,'grey-dot-line':!status.isActive}"></span>
        </div>
          <span  *ngIf="!status.isStatus" [ngClass]="{'dot-line':status.isActive,'grey-dot-line':!status.isActive}"></span>
        <span [ngClass]="{'line':status.isActive,'grey-line':!status.isActive}"></span></div>
      <div  [ngClass]="{'status':status.isActive,'grey-status':!status.isActive}">{{status.title}}</div>
      <div class="time">{{status.time}}</div>
    </li>
    <!-- <li>
      <div class="icon-wrap">
        <svg-icon [iconName]="'delivery-created.svg'" ></svg-icon>
      </div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Delivery Created</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'picking-started.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Picking started</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'packing-completed.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Packing completed</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'issue-posted.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Goods issue posted</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'picked-up.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Picked up from Bosch</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'in-transit.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">in transit</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'out-for-delivery.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Out for delivery</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li>
    <li>
      <div class="icon-wrap"><svg-icon [iconName]="'delivered.svg'" ></svg-icon></div>
      <div class="flex-center dot-wrap"><span class="line"></span><span class="dot-line"></span><span class="line"></span></div>
      <div class="status">Delivered</div>
      <div class="time">2024/01/12 2:15 PM</div>
    </li> -->
    <li>
      <div class="icon-wrap"></div>
      <div class="flex-center dot-wrap"><span class="line"></span><i class="end-line"></i></div>
    </li>
  </ul>
</div>
